module.exports = __webpack_public_path__ + "img/minimize.d915c612.svg";